import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const TooltipInfo = ({ isSingle, hasFields }) => {
  const { t } = useTranslation("core", { keyPrefix: "skillBadge.tooltipInfo" });
  const items = useMemo(
    () => [
      {
        name: "fields",
        hidden: !hasFields
      },
      {
        name: "exportEdit"
      },
      {
        name: "export"
      }
    ],
    [hasFields]
  );

  return (
    <div style={{ maxWidth: 200 }}>
      {items
        .filter(({ hidden }) => !hidden)
        .map(({ name }) => (
          <p key={name}>
            {t(`${name}.label`, {
              content: isSingle ? t(`${name}.single`) : t(`${name}.multiple`)
            })}
          </p>
        ))}
    </div>
  );
};

TooltipInfo.propTypes = {
  isSingle: PropTypes.bool,
  hasFields: PropTypes.bool
};

export default TooltipInfo;
